(function() {
    if (typeof alain_styles_images === "undefined" || alain_styles_images === null || alain_styles_images.length < 1) return;

    var vi = new Vue({
        el: "#styles_de_poses",
        data: {
            images: alain_styles_images,
            selected: 0
        },
        methods: {
            figstyle: function(index) {
                return {
                    opacity: this.selected === index ? 1 : 0,
                    pointerEvents: this.selected === index ? "unset" : "none"
                };
            },
            imgstyle: function(index) {
                return {
                    marginTop: this.images[index].top_offset + "px"
                };
            },
            selectnext: function() {
                if (this.selected + 1 >= this.images.length) {
                    this.selected = 0;
                } else {
                    this.selected++;
                }
            },
            selectprev: function() {
                if (this.selected <= 0) {
                    this.selected = this.images.length - 1;
                } else {
                    this.selected--;
                }
            }
        }
    });

    var x_coord = null;
    var y_coord = null;
    var viewport = document.querySelector("#styles_de_poses > .viewport");
    viewport.addEventListener('touchstart', function(ev) {
        x_coord = ev.changedTouches ? ev.changedTouches[0].clientX : ev.clientX;
        y_coord = ev.changedTouches ? ev.changedTouches[0].clientY : ev.clientY;
    });
    viewport.addEventListener('touchend', function(ev) {
        if (x_coord || x_coord === 0) {
            var dx = (ev.changedTouches ? ev.changedTouches[0].clientX : ev.clientX) - x_coord, s = Math.sign(dx);
            var dy = (ev.changedTouches ? ev.changedTouches[0].clientY : ev.clientY) - y_coord;
            if (dy > 50 || dy < -50) {
                x_coord = null;
                return;
            }
            if (s > 0) {
                // Prev
                vi.selectprev();
            } else if (s < 0) {
                // Next
                vi.selectnext();
            }
            x_coord = null;
        }
    });
    // viewport.addEventListener('touchmove', function(ev) {
    //     ev.preventDefault();
    // });
}());
